// verticalScrollToElementTop
// arg: element: html element you'd like to focus
// Scrolls the page so that the element is at the top of the page (awaitable).
window.verticalScrollToElementTop = function(element) {
    return new Promise((resolve) => {
        if (element) {
           
            // Sets the maximum time we are willing to wait for a scroll before we return.
            const timeout = setTimeout(() => {
                resolve();
            }, 2000);

            // We store the last known scroll position and how many frames we have been stuck for.
            // If we are stuck for too many frames (e.g. there is no room to scroll) we return, as scolling is considered done.
            let lastScrollY = window.scrollY;
            let stuckCount = 0;
            
            const checkIfDone = () => {
                const rect = element.getBoundingClientRect();
                // If element is at (or very near) the top, resolve
                if (Math.abs(rect.top) < 2) {
                    clearTimeout(timeout);
                    resolve();
                } else {
                    // If scroll position hasn't changed for several frames, assume stuck
                    if (window.scrollY === lastScrollY) {
                        stuckCount++;
                        if (stuckCount >= 10) { // 10 (around 160ms)
                            clearTimeout(timeout);
                            resolve();
                            return;
                        }
                    } else {
                        stuckCount = 0;
                        lastScrollY = window.scrollY;
                    }
                    requestAnimationFrame(checkIfDone);
                }
            };
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            checkIfDone();
        } else {
            console.warn(`Element could not be found.`);
            resolve();
        }
    });
};

// getHorizontalScrollPosition:
// arg: elementId: html element id of the parent scrolling container
//
// Gets the current horizontal scroll position of a parent container, that is, the container of the elements
// that you'd like to apply a parallax effect to.
window.getHorizontalScrollPosition = function (elementId) {
    const container = document.getElementById(elementId);
    return container ? container.scrollLeft : 0;
};

// applyLinearHorizontalParallaxScroll:
// arg: scrollLeft: the initial horizontal starting position of a scroll container. Get this by calling 'getScrollPosition'
// arg: elementIds: an array of html element ids, where those elements are stacked by z-index and you'd like to apply
//  different rates of horizontal scrolling to. The function applies more scrolling to the end of the array than the start
//  so for a realistic effect, higher z-index elements should be put at the start of the array.
// arg (optional): multiplier: affects how much scrolling occurs (that is, how far away the background elements appear).
//  a value of 1 implies the foreground is equidistant to the distance between all of the other layers. A lower value
//  reduces scrolling level.

// Creates a parallax effect by applying different rates of horizontal scrolling to each element. It does so artificially
// by applying translation to the element in the x direction.
window.applyLinearHorizontalParallaxScroll = function (scrollLeft, elementIds, multiplier = 1) {
    let elements = [];
    for(var childElementId of elementIds){
        elements.push(document.getElementById(childElementId))
    }

    if (elements.length > 0) {
        let translationIncrement = multiplier/(elements.length + 1) // we want the closest element to screen scroll slightly less (<1px) than the scrolling container 
        let startingVal = 1 - multiplier
        let element
        for(let i=0; i< elements.length; i++){
            element = elements[i]
            if(element){
                element.style.transform = `translateX(${scrollLeft * (startingVal + translationIncrement * (i+1))}px)`
            }
        }
    }
};

// applyCustomHorizontalParallaxScroll:
// arg: scrollLeft: the initial horizontal starting position of a scroll container. Get this by calling 'getScrollPosition'
// arg: elementIds: an array of html element ids, where those elements are stacked by z-index and you'd like to apply
//  different rates of horizontal scrolling to. The function applies more scrolling to the end of the array than the 
//  start so for a realistic effect, higher z-index elements should be put at the start of the array.
// arg (optional): customLayerTranslations: an array that should be length elementIds.length, which represents how much
//  each layer should move on scroll, where 0 is moving completely in time with the parent scrolling container and 1 is 
//  not moving. Eg: [0,0.5,1]: Element 0 has no parallax (moves with the scrolling container. Element 1 moves at 50%
//  of the rate of the scrolling container. Element 2 does not move - stays still despite parent scrolling container scrolls.

// Creates a parallax effect by applying different rates of horizontal scrolling to each element. It does so artificially
// by applying translation to the element in the x direction. This version accepts an array which specifies the 
// translation of each layer.
window.applyCustomHorizontalParallaxScroll = function (scrollLeft, elementIds, customLayerTranslations) {
    let elements = [];
    if(elementIds==null || customLayerTranslations == null){
        return
    }
    for(var childElementId of elementIds){
        elements.push(document.getElementById(childElementId))
    }

    if (elements.length > 0) {
        let element
        for(let i=0; i< elements.length; i++){
            element = elements[i]
            if(element){
                element.style.transform = `translateX(${scrollLeft * (customLayerTranslations[i])}px)`
            }
        }
    }
};

// scrollElementToHorizontalCenter:
// Scrolls a container with an ease-in-out animation until a given element is at the center of this container.
// arg: containerId: the element id of a container within with you would like to center the element on trigger
// arg: elementId: the element id of an element which you would like to animate a scroll to the center of its parent container (given by containerId)
// arg (optional): duration: how many milliseconds you would like the ease-in-out animation to last for.
window.scrollElementToHorizontalCenter= async function (containerId, elementId, duration= 1000) {
    const container = document.getElementById(containerId);
    const element = document.getElementById(elementId);
    const elementBoundingRect = element.getBoundingClientRect()
    const halfElementWidth = (elementBoundingRect.right - elementBoundingRect.left)/2
    const leftElementSide = elementBoundingRect.left
    const halfWindowWidth = window.innerWidth/2
    const distance =  leftElementSide - (halfWindowWidth - halfElementWidth)
    const startPosition = container.scrollLeft;

    const startTime = performance.now();

    function scroll() {
        // Calculate the time elapsed
        const elapsed = performance.now() - startTime;

        // Calculate the progress as a value between 0 and 1
        const progress = Math.min(elapsed / duration, 1);

        // Apply easing (ease-in-out) for smooth effect
        const easeInOutProgress = 0.5 - 0.5 * Math.cos(Math.PI * progress);

        // Update scrollLeft position
        container.scrollLeft = startPosition + easeInOutProgress * distance;

        // Continue the animation if the duration is not yet complete
        if (progress < 1) {
            requestAnimationFrame(scroll);
        }
    }

    // Start the animation
    requestAnimationFrame(scroll);
};

window.scrollToBottom = function (element) {
    if (element == null || typeof(element.scrollTo) == 'undefined') return;

    setTimeout(function() {
        element.scrollTo({ left: 0, top: element.scrollHeight, behavior: "smooth" });
    }, 50);
}

// Scrolls the viewport to the top and resolves when the scroll finishes.
window.scrollViewportToTop = function() {
    return new Promise((resolve) => {
        const checkIfDone = () => {
            if (window.scrollY === 0) {
                resolve();
            } else {
                requestAnimationFrame(checkIfDone);
            }
        };
        window.scrollTo({ top: 0, behavior: 'smooth' });
        checkIfDone();
    });
};